<template>
  <div class="m-spotify">
    <iframe src="https://open.spotify.com/embed/user/chinggizkhan/playlist/2157BVVV7uCn5sZc9qDqW5" width="375" height="380" frameborder="0" allowtransparency="true"></iframe>

  </div>
</template>

<script>
export default {
  name: 'spotify'
}
</script>

<style lang="scss" scoped>

.m-spotify {
  text-align: center;

  iframe {
    width: 100%;
    max-width: 375px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Spotify.vue